import React from 'react';

const applyComponentDataAttribute = (element, componentName, componentPath) => {
    if (!element.hasAttribute('data-component')) {
        element.setAttribute('data-component', componentName);
    }
    if (!element.hasAttribute('path')) {
        element.setAttribute('path', componentPath);
    }
    Array.from(element.children).forEach(child => applyComponentDataAttribute(child, componentName, componentPath));
};

const ComponentWrapper = ({ component: Component, componentName, componentPath, ...props }) => {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref.current) {
            applyComponentDataAttribute(ref.current, componentName, componentPath);
        }
    }, [componentName, componentPath]);

    return (
        <div ref={ref} data-component={componentName} path={componentPath}>
            <Component {...props} />
        </div>
    );
};

export default ComponentWrapper;
